import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography,
  CircularProgress,
  DialogTitle,
  DialogContent,
  IconButton
} from '@material-ui/core';
import { DialogWithFocusProvider } from 'components/layout';
import ClearIcon from '@material-ui/icons/Clear';
import { FetchAutoPricing } from 'api/revue/underwriteData';
import { appNotify } from "store/actions";
import AutoPricingResultsGrid from 'components/underwrite/acquisition/channelWorkflow/AutoPricingResultsGrid';

const AutoPricingResultsModal = ({
  isOpen,
  classes,
  selectedRows,
  setIsOpen,
  appNotify
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [autoPricingResults, setAutoPricingResults] = useState([]);

  useEffect(() => {
    if (isOpen) {
      setIsLoading(true);
      GetAutoPricing(selectedRows.map(row => row.id));
    }
  }, [isOpen])

  const GetAutoPricing = (txnOppIds) => {
    FetchAutoPricing(txnOppIds).then(res => {
      if (!res) {
        appNotify('Autopricing response not found', 'warning');
      } else {
        setAutoPricingResults(res);
      }
    }).catch(error => {
      appNotify(error.message, 'error');
    }).finally(() => {
      setIsLoading(false);
    });
  }

  return (
    <DialogWithFocusProvider
      open={isOpen} onClose={() => setIsOpen(false)} maxWidth='md' fullWidth classes={{ paper: classes.dialogContainer }} >
      <DialogTitle disableTypography={true} className={classes.dialogTitleRoot}>
        <Typography variant={'h6'}>
          <span>Autopricing results for {`${selectedRows.length} transaction ${selectedRows.length > 1 ? 'opportunities' : 'opportunity'}`}</span>
        </Typography>
      </DialogTitle>
      <IconButton className={classes.closeButton} onClick={() => setIsOpen(false)}>
        <ClearIcon fontSize="inherit" />
      </IconButton>
      <DialogContent>
        {!isLoading ?
          <AutoPricingResultsGrid results={autoPricingResults} />
          : <div className={classes.loadingWrapper}>
            <CircularProgress />
          </div>
        }
      </DialogContent>
    </DialogWithFocusProvider>
  );
};

const styles = theme => ({
  dialogContainer: {
    // height: '50%',
    minHeight: 350
  },
  loadingWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  },
  filterField: {
    marginTop: 16
  },
  dialogTitleRoot: {
    paddingBottom: 0
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    backgroundColor: '#ffffff'
  },
});

const mapState = state => {
  return {
  }
};

const mapDispatch = dispatch => ({
  appNotify: (message, variant, options) => dispatch(appNotify(message, variant, options)),
});

export default compose(
  withStyles(styles),
  connect(mapState, mapDispatch)
)(AutoPricingResultsModal);